import styles from './Footer.module.css';
import { Container, Col, Row, ListGroup, Button, Form, FormControl, Accordion} from 'react-bootstrap';

import fb from '../../assets/icons/fb.png';
import twitter from '../../assets/icons/twitter.png';
import insta from '../../assets/icons/instagram.png';
import linkedin from '../../assets/icons/linkedin.png';
import yt from '../../assets/icons/yt.png';
import king from '../../assets/icons/king.jpg';
import podcast from '../../assets/imgs/podcast.png';
import asin5 from '../../assets/imgs/asin5.png';
import naira from '../../assets/icons/naija.png';
import logo from '../../assets/imgs/logo.png';



export const Footer = () =>{
    return <div>
        <div  className={`${styles.footerDesk}`}>
        <Container>
            <Col>
            <div>
                <h2 className={`${styles.title}`}>Subscribe to our newsletter to get latest 
news and updates</h2>    
                <p className={`${styles.desc}`} ></p>
            </div>  
            <div>
            <Form className={`d-flex ${styles.form}`}>
                            <FormControl type='email' placeholder='Enter your Email Address' className={`${styles.formctr}`}/>
                            <Button variant='primary' className={` ms-2 ${styles.btn1}`}>Subscribe</Button>
                        </Form>
            </div>          
            </Col>
        </Container>

        <Container fluid>
            <Container>
                <Row className={`${styles.footerrow}`} lg={5} xs={1}>
                    <Col className={`${styles.footcol1}`}>
                        <img src={logo} alt='ullweb logo'  className={`${styles.logo}`}/>
                        <p className={`${styles.footertext}`}>ULLWEB is a workspace for all your 
                            web and app products. A free-to-use freelance platform that allows you build
                            any project at your available budget and 
                            timeline while in control of your web files.</p>
                        <img src={asin5} alt='Asin5 Food for all logo'  className={`img-fluid ${styles.asin5}`}/>

                    </Col>                    
                   <Col  className={`${styles.prod}`}>
                    <h3 className={`${styles.Fheading}`}>Product</h3>
                    <p className={`${styles.item}`}>SiteULL</p>
                    <p className={`${styles.item}`}>HostULL</p>
                    <p className={`${styles.item}`}>CloudULL</p>
                    <p className={`${styles.item}`}>SalesULL</p>
                    <p className={`${styles.item}`}>ManageULL</p>
                    <p className={`${styles.item}`}>Branch </p>
                    </Col>

                    <Col className={`${styles.company}`}>
                    <h3 className={`${styles.Fheading}`}>Company</h3>
                    <p className={`${styles.item}`}>About Us</p>
                    <p className={`${styles.item}`}>Brand Assets</p>
                    <p className={`${styles.item}`}>Investor Relations</p>
                    <p className={`${styles.item}`}>News & Press Room</p>
                    <p className={`${styles.item}`}>Social Responsibility</p>
                    <p className={`${styles.item}`}>Jobs & Careers  </p>
                    </Col>

                    <Col className={`${styles.comm}`}>
                    <h3 className={`${styles.Fheading}`}>Community</h3>
                    <p className={`${styles.item}`}>Marketplace & Vendors</p>
                    <p className={`${styles.item}`}>Reseller/Affiiate Program</p>
                    <p className={`${styles.item}`}>Ambassadorship Program</p>
                    <p className={`${styles.item}`}>Student Work Program</p>
                    <p className={`${styles.item}`}>APIs and Integrations</p>
                    <p className={`${styles.item}`}>ULLWEB vs Upwork vs Fiverr  </p>
                    </Col>

                    <Col  className={`${styles.support}`}>
                    <h3 className={`${styles.Fheading}`}>Support</h3>
                    <p className={`${styles.item}`}>FAQ</p>
                    <p className={`${styles.item}`}>Growth Blog</p>
                    <p className={`${styles.item}`}>Support Center</p>
                    <p className={`${styles.item}`}>Guides & Use Cases</p>
                    <p className={`${styles.item}`}>Video Tutorial</p>
                    <p className={`${styles.item}`}>Contact </p>
                    </Col>

                </Row>
            </Container>
            <Container>
            <Row className={`${styles.lowerf}`}>
                <Col  className={`${styles.lowerf}`}>
                    <p className={`${styles.copr}`}>© 2022 ULLWEB Technology. All rights reserved.</p>
                </Col>

                <Col className={`${styles.lowerf2}`}>
                <p className={`${styles.naija}`}>Web in Nigeria<img src={naira} /></p>
                </Col>

                <Col className={`ms-2 ${styles.scial}`}>
                <ListGroup horizontal>
                    <ListGroup.Item className={`border-0 ms-3 ${styles.fb}`}><img src={fb} alt='facebook' /></ListGroup.Item>
                    <ListGroup.Item className={`border-0 ms-2 ${styles.twitter}`}><img src={twitter} alt='twitter' /></ListGroup.Item>
                    <ListGroup.Item className={`border-0 ms-2 ${styles.inst}`}><img src={insta} alt='instagram' /></ListGroup.Item>
                    <ListGroup.Item className={`border-0 ms-2 ${styles.linkedin}`}><img src={linkedin} alt='Linkedin' /></ListGroup.Item>
                    <ListGroup.Item className={`border-0 ms-2 ${styles.yt}`}><img src={yt} alt='facebook' /></ListGroup.Item>
                    <ListGroup.Item className={`border-0 ms-2 ${styles.king}`}><img src={king} alt='king' /></ListGroup.Item>
                    <ListGroup.Item className={`border-0 me-2 mb-3 ${styles.podcast}`}><img src={podcast} alt='podcast' className={`border-0 ms-3 ${styles.podcast}`} /></ListGroup.Item>



                </ListGroup>
                </Col>
            </Row>
        </Container>

        </Container>
</div>
       












        {/* mobile  */}











        <Container fluid className={`${styles.footermobile}`}>
            <Container >
               <div className={`${styles.footermobile}`}>
                <div className={`${styles.footerrw}`}>
                    <Col className={`${styles.footcol1}`} xs={12}>
                        <img src={logo} alt='ullweb logo'  className={`${styles.logo}`}/>
                        <p className={`${styles.footertext}`}>ULLWEB is a workspace for all your 
                            web and app products. A free-to-use freelance platform that allows you build
                            any project at your available budget and 
                            timeline while in control of your web files.</p>
                        <img src={asin5} alt='Asin5 Food for all logo'  className={`img-fluid ${styles.asin5}`}/>

                    </Col>  
                    <Col>  
                   <Accordion className={`border-0 mb-5`}>
{/* 
                   <Col  className={`${styles.pod}`} xs={12} sm={12}> */}
                    <Accordion.Item eventKey="0" className={`border-0 mb-4`} style={{width: '320px' }}>
                        <Accordion.Header className={` ${styles.Fheading}`}>Product</Accordion.Header>
                        <Accordion.Body>
                                    
                    <p className={`${styles.iem}`}>SiteULL</p>
                    <p className={`${styles.itm}`}>HostULL</p>
                    <p className={`${styles.iem}`}>CloudULL</p>
                    <p className={`${styles.iem}`}>SalesULL</p>
                    <p className={`${styles.iem}`}>ManageULL</p>
                    <p className={`${styles.iem}`}>Branch </p>

                    </Accordion.Body>
                </Accordion.Item>
                    {/* </Col> */}

                    {/* <Col className={`${styles.comany}`} xs={12} sm={12}> */}
                    <Accordion.Item eventKey="2" className={`border-0 mb-4`} style={{width: '320px'}}>
                     <Accordion.Header className={`${styles.Fheading}`}> Company</Accordion.Header>
                    <Accordion.Body>
                    <p className={`${styles.item}`}>About Us</p>
                    <p className={`${styles.item}`}>Brand Assets</p>
                    <p className={`${styles.item}`}>Investor Relations</p>
                    <p className={`${styles.item}`}>News & Press Room</p>
                    <p className={`${styles.item}`}>Social Responsibility</p>
                    <p className={`${styles.item}`}>Jobs & Careers  </p>
                    </Accordion.Body>
                 </Accordion.Item>

                 {/* </Col> */}
                    {/* <Col className={`${styles.comm}`}> */}
                    <Accordion.Item eventKey="3" className={`border-0 mb-4`} style={{width: '320px'}}>
                     <Accordion.Header className={`${styles.Fheading}`}> Community</Accordion.Header>
                    <Accordion.Body>
                    {/* <h3 className={`${styles.Fheading}`}></h3> */}
                    <p className={`${styles.item}`}>Marketplace & Vendors</p>
                    <p className={`${styles.item}`}>Reseller/Affiiate Program</p>
                    <p className={`${styles.item}`}>Ambassadorship Program</p>
                    <p className={`${styles.item}`}>Student Work Program</p>
                    <p className={`${styles.item}`}>APIs and Integrations</p>
                    <p className={`${styles.item}`}>ULLWEB vs Upwork vs Fiverr  </p>
                    </Accordion.Body>
                 </Accordion.Item>
                    {/* </Col> */}

                    {/* <Col  className={`${styles.support}`}> */}
                    <Accordion.Item eventKey="4" className={`mb-5 border-0`} style={{width: '320px'}}>
                     <Accordion.Header className={`${styles.Fheading}`}> Support</Accordion.Header>
                    <Accordion.Body>
                    {/* <h3 className={`${styles.Fheading}`}></h3> */}
                    <p className={`${styles.item}`}>FAQ</p>
                    <p className={`${styles.item}`}>Growth Blog</p>
                    <p className={`${styles.item}`}>Support Center</p>
                    <p className={`${styles.item}`}>Guides & Use Cases</p>
                    <p className={`${styles.item}`}>Video Tutorial</p>
                    <p className={`${styles.item}`}>Contact </p>
                    </Accordion.Body>
                 </Accordion.Item>
                    {/* </Col> */}
                    </Accordion>
                    </Col>
                </div>
                </div>
            </Container>
            <div className={`${styles.footermobile}`}>

            <Container>
            <Row className={`${styles.lowerf}`}>
                <Col  className={`${styles.lowerf}`}>
                    <p className={`${styles.copr}`}>© 2022 ULLWEB Technology. All rights reserved.</p>
                </Col>

                <Col className={`${styles.lowerf2}`}>
                <p className={`${styles.naija}`}>Web in Nigeria<img src={naira} /></p>
                </Col>

                <Col className={`ms-2 ${styles.scial}`}>
                <ListGroup horizontal>
                    <ListGroup.Item className={`border-0  ${styles.fb}`}><img src={fb} alt='facebook' /></ListGroup.Item>
                    <ListGroup.Item className={`border-0 ms-2 ${styles.twitter}`}><img src={twitter} alt='twitter' /></ListGroup.Item>
                    <ListGroup.Item className={`border-0 ms-2 ${styles.inst}`}><img src={insta} alt='instagram' /></ListGroup.Item>
                    <ListGroup.Item className={`border-0 ms-2 ${styles.linkedin}`}><img src={linkedin} alt='Linkedin' /></ListGroup.Item>
                    <ListGroup.Item className={`border-0 ms-1 ${styles.king}`}><img src={king} alt='king' /></ListGroup.Item>
                    <ListGroup.Item className={`border-0 mb4 ${styles.podcast}`}><img src={podcast} alt='podcast' className={` ${styles.podcast}`} /></ListGroup.Item>
                    <ListGroup.Item className={`border-0 ms- ${styles.yt}`}><img src={yt} alt='facebook' /></ListGroup.Item>



                </ListGroup>
                </Col>
            </Row>
       
        </Container>
        </div>
        </Container>

       
    </div>
}